// Hook - pelna karta klienta z analityka
// GET /api/ui/trader/insights/clients/{clientId}

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetTraderInsightsClientResponse } from 'api/types/traderInsights';

const getTraderInsightsClient = (clientId: number): Promise<IGetTraderInsightsClientResponse> =>
  axios.get(`/trader/insights/clients/${clientId}`);

export const useGetTraderInsightsClient = (
  clientId: number,
  options?: UseQueryOptions<IGetTraderInsightsClientResponse, IError>
) =>
  useQuery<IGetTraderInsightsClientResponse, IError>(
    ['trader-insights-client', clientId],
    () => getTraderInsightsClient(clientId),
    options
  );
